import {
	GET_USER_HAVENT_SIG_IN,
	getRemienderEmail,
	ORGANIZATION_DATA_EDIT,
	reminderEmailPost,
	updateOrganizationInformation,
	UsersResponse
} from 'api'
import {
	Button,
	Input,
	ReminderPeopleTable,
	TailwindModal,
	Typography
} from 'components'
import { useContextPeopleBatches } from 'context'
import { useToast } from 'hooks'

import { getOrganizationInfo } from 'api/get/superAdminDashboard/superAdminDashboard'
import { createDeepLink } from 'api/post/branch'
import { ArgMutationBranch } from 'components/organizationInformation/interfaceGenerateBranch.type'
import {
	GenericModalProps,
	Icons,
	LoginReminderItem,
	LoginReminderResponse,
	ModalData,
	PeopleMyPeopleResponse,
	TypographyTypes,
	UpdaterganizationRequest
} from 'interfaces'
import { debounce } from 'lodash'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useMutation, useQuery } from 'react-query'
import Cookies from 'universal-cookie'
import { configGenaral, encryptData } from 'utils'
import { ReminderConfirmModal } from './reminderConfirmModal'

export const SendReminderModal: React.FC<GenericModalProps<number[]>> = ({
	open,
	setOpen,
	closeBefore,
	secondCloseBefore,
	setMyPeopleDataSelected
}) => {
	const cookies = new Cookies()
	const organizationId = cookies.get('organization_id')

	const { register, resetField, setValue, watch } = useForm<{
		search: string
	}>({
		mode: 'onChange'
	})
	const watchSearch = watch('search')
	const { showToast } = useToast()
	const { itemUser, setItemUser, setSelectedUsers, setOrganizationFollower } =
		useContextPeopleBatches()
	const [keyBranch, setKeyBranch] = useState<string | null>(null)

	const [confirmReminder, setConfirmReminder] = useState(false)
	const [page, setPage] = useState(0)
	const [dataSelected, setDataSelected] = useState<number[]>([])
	const [searchTerm, setSearchTerm] = useState('')
	const [transformedData, setTransformedData] =
		useState<LoginReminderResponse | null>(null)
	const [searchData, setSearchData] = useState<LoginReminderResponse | null>(
		null
	)
	const [modalData, setModalData] = useState<ModalData | null>(null)
	const {
		data: dataUser,
		isLoading: isLoadingUser,
		isRefetching
	} = useQuery(
		[GET_USER_HAVENT_SIG_IN],
		() => getRemienderEmail(organizationId),
		{
			enabled: itemUser.length === 0
		}
	)

	const {
		data: responseData,
		isLoading: isLoadingOrg,
		isRefetching: isRefetchingOrg
	} = useQuery({
		queryKey: [ORGANIZATION_DATA_EDIT, organizationId],
		queryFn: () => getOrganizationInfo(organizationId),
		enabled: organizationId !== undefined,
		refetchOnWindowFocus: false
	})
	const dataOrganization = responseData?.organization

	const handleSearch = debounce((value: string) => {
		setSearchTerm(value)
	}, 300)

	useEffect(() => {
		if (transformedData) {
			const filteredData = {
				...transformedData,
				items: transformedData.items.filter(
					item =>
						item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
						item.email.toLowerCase().includes(searchTerm.toLowerCase())
				)
			}
			setSearchData(filteredData)
		}
	}, [searchTerm, dataUser, itemUser])

	const transformData = (
		informationUser: PeopleMyPeopleResponse
	): LoginReminderResponse => {
		return {
			items: informationUser.items.map(item => ({
				id: item.user_id,
				name: item.full_name,
				email: item.email
			})) as LoginReminderItem[],
			total: informationUser.total,
			page: informationUser.page,
			size: informationUser.size,
			pages: informationUser.pages
		}
	}

	useEffect(() => {
		if (itemUser && itemUser.length > 0) {
			const usersWithDevice = itemUser.filter(item => item.device_type !== null)
			if (usersWithDevice.length > 0) {
				showToast(
					'Warning',
					'Some selected users are already active and logged in',
					'warning'
				)
			}
			const userWithoutDevice = itemUser.filter(
				item => item.device_type === null
			)

			setDataSelected(userWithoutDevice.map(item => item.user_id))
			setTransformedData(
				transformData({
					items: userWithoutDevice,
					total: 0,
					page: 1,
					size: 10,
					pages: 1
				})
			)
		} else if (dataUser) {
			setDataSelected(dataUser.items.map(item => item.user_id))
			setTransformedData(transformData(dataUser as PeopleMyPeopleResponse))
		}
	}, [itemUser, dataUser])

	const quantityUser = (dataSelected && dataSelected.length.toString()) || ''

	const { mutate, isLoading } = useMutation({
		mutationFn: (params: UsersResponse) =>
			reminderEmailPost(organizationId, params),
		onSuccess: () => {
			setModalData({
				icon: Icons.checkCircle,
				descripcion: `Reminders sent successfully to ${quantityUser} users`,
				labelButton: 'Ok',
				showCloseButton: false,
				onClickAction: () => {
					setConfirmReminder(false)
					setModalData(null)
					setOpen(false)
					secondCloseBefore?.(false)
					closeBefore?.(false)
					setSelectedUsers([])
					setItemUser([])
					setOrganizationFollower([])
					setMyPeopleDataSelected?.([])
				}
			})
		},
		onError: (error: Error) => {
			console.error('Failed to send reminders:', error)
		}
	})

	const handleSendReminders = (): void => {
		if (!transformedData) return

		const selectedUsers = transformedData.items.filter(item =>
			dataSelected.includes(item.id)
		)
		const requestData = {
			users: selectedUsers.map(user => ({
				id: user.id,
				email: user.email
			}))
		}

		mutate(requestData)
	}

	useEffect(() => {
		return () => {
			setDataSelected([])
			setTransformedData(null)
		}
	}, [])

	useEffect(() => {
		if (
			dataOrganization?.build_app_branch_key &&
			!dataOrganization?.branch_url_migration
		) {
			const decryptBranchKey = encryptData(
				dataOrganization?.build_app_branch_key ?? '',
				'decrypt'
			)

			setKeyBranch(decryptBranchKey)
		}
	}, [responseData])

	const { mutate: mutateOrganization } = useMutation({
		mutationFn: (params: Partial<UpdaterganizationRequest>) =>
			updateOrganizationInformation(organizationId, params),
		onSuccess: async data => {
			if (data?.message === 'Organization updated successfully') {
				handleSendReminders()
			}
		},
		onError: (error: Error) => {
			console.warn('success')
			showToast('Error', error.message, 'error')
		}
	})

	const { mutate: generateBranchUrl, isLoading: loadingBranchUrl } =
		useMutation({
			mutationFn: (params: ArgMutationBranch) =>
				createDeepLink(params.body, params.key),
			onSuccess: data => {
				if (data?.url) {
					if (data.key) {
						const dataUrl: Partial<UpdaterganizationRequest> = {
							organization: {
								[data.key]: data?.url
							}
						}
						mutateOrganization(dataUrl)
					}
				}
			},
			onError: (error: Error) => {
				showToast('Error', error.message, 'error')
			}
		})

	const handleGenerateBranch = (): void => {
		const deepLinkBody = {
			alias: `${dataOrganization?.name
				.toLowerCase()
				.replaceAll(' ', '')}legacy`,
			branch_key: keyBranch as string,
			data: {
				$custom_meta_tags: `migration_slug=${dataOrganization?.slug}`
			}
		}

		generateBranchUrl({ body: deepLinkBody, key: 'branch_url_migration' })
	}

	const loading = isLoading || loadingBranchUrl

	const loadingTable =
		isLoadingUser || isRefetching || isLoadingOrg || isRefetchingOrg

	return (
		<TailwindModal
			open={open}
			setOpen={() => {
				closeBefore?.(false)
				setOpen(false)
			}}
			title="Send Login reminders"
			titleClassName="font-bold text-[24px] leading-[28px]"
			className="w-[513px] h-full p-4 rounded-[16px] overflow-y-auto"
		>
			<div className="flex flex-col justify-between items-center h-[95%] gap-2 pt-6">
				<div className="w-full flex flex-col gap-4">
					<div className="flex justify-start w-full">
						<Typography
							type={TypographyTypes.p}
							className="text-[16px] font-normal leading-[24px] text-left"
							title="The following users wil be reminded to join the platform:"
							fontLeading="12/12"
						/>
					</div>
					<Input
						name="search"
						placeholder="Search Users"
						className="!p-[unset] font-Inter"
						register={register}
						rightIcon={Icons.cancel}
						rightClick={() => {
							setSearchData(null)
							resetField('search')
						}}
						cantLimit={configGenaral.maxSearchValue}
						search
						watchValue={watchSearch}
						setValueInput={setValue}
						inputClassName="!p-[unset] !py-1 !px-2 !rounded-xl"
						inputFieldClassName="focus:ring-blue-primary !focus:border-blue-primary"
						inputFocus
						borderFull={false}
						onChange={e => handleSearch(e.target.value)}
					/>

					<ReminderPeopleTable
						data={
							(searchData ||
								transformedData) as unknown as LoginReminderResponse
						}
						isLoading={loadingTable}
						page={page}
						setPage={setPage}
						dataSelected={dataSelected}
						setDataSelected={setDataSelected}
					/>
				</div>
				<div className="flex flex-col gap-4">
					<div className="border-blue-primary border-solid border-[1px] rounded-[2.5rem] p-[16px] w-full">
						<div className="flex flex-row justify-between items-center">
							<Typography
								type={TypographyTypes.p}
								className="text-[24px] font-bold leading-[24px]"
								title="Total Users:"
								fontLeading="24/29"
							/>
							<div
								className="bg-blue-primary rounded-full flex items-center justify-center"
								style={{
									width: quantityUser.length > 1 ? '58px' : '36px',
									height: '36px',
									minWidth: '36px'
								}}
							>
								<Typography
									type={TypographyTypes.p}
									className="text-[24px] text-white font-bold leading-[24px]"
									title={quantityUser}
									fontLeading="24/29"
								/>
							</div>
						</div>
					</div>
					<div className="w-full flex flex-col sm:flex-row justify-between gap-4 ">
						<Button
							label="Cancel"
							className="!min-w-[14rem]"
							color="Transparent"
							onClick={() => {
								setOpen(false)
								closeBefore?.(false)
							}}
						/>
						<Button
							label="Remind Selected users"
							className="!min-w-[14rem]"
							color="Primary"
							onClick={() => {
								setModalData({
									icon: Icons.warning,
									descripcion: `Are you sure you want to send login reminders to ${quantityUser} users?`,
									labelButton: 'Confirm',
									onClickAction: () => {
										if (!dataOrganization?.branch_url_migration) {
											handleGenerateBranch()
											return
										}
										handleSendReminders()
									},
									showCloseButton: true
								})
								setConfirmReminder(true)
							}}
							disabled={loadingTable || dataSelected.length === 0}
						/>
						{confirmReminder && (
							<ReminderConfirmModal
								open={confirmReminder}
								setOpen={() => {
									setConfirmReminder(false)
									setModalData(null)
								}}
								showCloseButton={modalData?.showCloseButton}
								icon={modalData?.icon}
								descripcion={modalData?.descripcion}
								buttonLabel={loading ? 'Loading...' : modalData?.labelButton}
								onClickConfirm={modalData?.onClickAction}
								isDisabledButton={loading}
							/>
						)}
					</div>
				</div>
			</div>
		</TailwindModal>
	)
}
